import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-56ddb262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "counters-wrapper" }
const _hoisted_2 = { key: 0 }

import { ref } from "vue";
import Button from "primevue/button";
import AudienceCounter from "./AudienceCounter.vue";
import SegmentCostCounter from "./SegmentCostCounter.vue";
import { useCategoriesStore } from "@/store/catalog_data/categories";
import { useSegmentsStore } from "@/store/segments/segments";
import { getFilterWithCategories } from "@/services/utils/Objects";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentCountersWrapper',
  props: {
    filter: {},
    isReadyToCount: { type: Boolean },
    countDisabledReason: {},
    settedAudienceCount: {},
    settedSegmentCost: {},
    isSegmentSetted: { type: Boolean }
  },
  emits: ["updateAudienceCount", "updateSegmentCost"],
  setup(__props: any, { emit: __emit }) {

const categoryStore = useCategoriesStore();
const segmentStore = useSegmentsStore();

const props = __props;

const emits = __emit;

const isLoading = ref(false);
const costCounterRef = ref<InstanceType<typeof SegmentCostCounter> | null>(
  null
);

const updateBothCounters = async () => {
  isLoading.value = true;

  try {
    const filter = getFilterWithCategories(
      props.filter,
      categoryStore.categoriesMap
    );

    // Параллельно запрашиваем аудиторию и стоимость
    const [count, costKopecks] = await Promise.all([
      segmentStore.getAudienceFilter(filter),
      segmentStore.getAudienceCost(filter),
    ]);

    // Конвертируем копейки в рубли для отображения
    const costRubles = costKopecks / 100;

    emits("updateAudienceCount", count);
    emits("updateSegmentCost", costRubles);

    if (costCounterRef.value) {
      costCounterRef.value.updateCost(costRubles);
    }
  } catch (error: any) {
    rootGetters.toast.show(
      "error",
      "Ошибка",
      error.message ||
        error.response?.data?.detail ||
        "Произошла ошибка при расчете стоимости сегмента"
    );
  } finally {
    isLoading.value = false;
  }
};

const handleAudienceUpdate = (count: number) => {
  emits("updateAudienceCount", count);
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AudienceCounter, {
      "setted-count": props.settedAudienceCount
    }, null, 8, ["setted-count"]),
    _createVNode(SegmentCostCounter, {
      "setted-cost": props.settedSegmentCost,
      ref_key: "costCounterRef",
      ref: costCounterRef
    }, null, 8, ["setted-cost"]),
    (!_ctx.isSegmentSetted)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            label: "Обновить",
            severity: "secondary",
            icon: "pi pi-refresh",
            class: "refresh-button",
            onClick: updateBothCounters,
            disabled: !_ctx.isReadyToCount,
            loading: isLoading.value
          }, null, 8, ["disabled", "loading"])
        ])), [
          [
            _directive_tooltip,
            {
        value: _ctx.countDisabledReason || '',
        class: 'white-tooltip-with-arrow',
        disabled: _ctx.isReadyToCount || !_ctx.countDisabledReason,
      },
            void 0,
            { bottom: true }
          ]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})